module.exports = __webpack_public_path__ + "img/sasaki.2bd22170.jpg";